import { BaseModel } from '@app/shared/models/base';

export abstract class AbstractStorageKey<T> {

    protected _key: string;
    get key(): string {
        return this._key;
    }


    constructor(key: string) {
        this._key = key;
    }

    public abstract parseFromJSON(json: string): T;
}

// Regular storage key can be used for simple stored values such as number or strings and enums
export class StorageKey<T> extends AbstractStorageKey<T> {
    public parseFromJSON(json: any): T {
        return JSON.parse(json);
    }
}

// Advanced storage key can be used for objects
export class AdvancedStorageKey<T extends BaseModel> extends StorageKey<T> {
    protected _constructorT: (new (json?: any) => T);

    constructor(key: string, constructorT: (new (json?: any) => T)) {
        super(key);
        this._constructorT = constructorT;
    }

    public parseFromJSON(json: string): T {
        const newObj = new this._constructorT(super.parseFromJSON(json));
        return newObj;
    }
}
